import React, { useMemo } from "react";
import {
    Alert,
    Card,
    Col,
    Descriptions,
    Divider,
    Empty,
    Modal,
    Row,
    Space,
    Tag,
    Typography,
} from "antd";

import PricePeriodActions from "../PricePeriodActions";
import { buildPriceComparisonViewModel } from "../../services/fuelPriceWorkbenchViewModel";
import PriceComparisonBreakdownTable from "./PriceComparisonBreakdownTable";

const { Paragraph, Text, Title } = Typography;

const SnapshotCard = ({ snapshot }) => {
    return (
        <Card
            size="small"
            title={
                <Space direction="vertical" size={0}>
                    <Tag color={snapshot.color}>{snapshot.title}</Tag>
                    <Text strong>{snapshot.subtitle}</Text>
                </Space>
            }
        >
            <Paragraph style={{ marginBottom: 12 }}>
                <Text type="secondary">统一口径总价</Text>
                <br />
                <Text strong style={{ fontSize: 18 }}>
                    {snapshot.total}
                </Text>
            </Paragraph>
            <Descriptions column={1} size="small">
                {snapshot.rows.map((row) => (
                    <Descriptions.Item key={row.label} label={row.label}>
                        {row.value}
                    </Descriptions.Item>
                ))}
            </Descriptions>
        </Card>
    );
};

const PriceComparisonModal = ({
    open,
    period,
    onClose,
    onViewDetail,
    onOpenOurPrice,
    onOpenSupplierQuote,
    onConfirm,
    onDispute,
}) => {
    const comparison = useMemo(() => buildPriceComparisonViewModel(period), [period]);

    return (
        <Modal
            title={comparison ? `周期双快照比较 · ${comparison.title}` : "周期双快照比较"}
            open={open}
            onCancel={onClose}
            footer={null}
            width={1080}
            destroyOnClose
        >
            {!comparison ? (
                <Empty description="暂无可比较周期" />
            ) : (
                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                    <Card size="small">
                        <Title level={5} style={{ marginTop: 0 }}>
                            周期总览
                        </Title>
                        <Descriptions column={2} size="small">
                            {comparison.meta.map((item) => (
                                <Descriptions.Item key={item.label} label={item.label}>
                                    {item.value}
                                </Descriptions.Item>
                            ))}
                        </Descriptions>
                        <Divider style={{ margin: "16px 0" }} />
                        <Descriptions column={3} size="small">
                            {comparison.actionSummary.map((item) => (
                                <Descriptions.Item key={item.label} label={item.label}>
                                    {item.value}
                                </Descriptions.Item>
                            ))}
                        </Descriptions>
                    </Card>

                    <Card size="small" title="周期级动作">
                        <Paragraph type="secondary" style={{ marginTop: 0 }}>
                            这里的动作直接作用于整个价格周期，分项只负责解释，不独立拥有状态机。
                        </Paragraph>
                        <PricePeriodActions
                            period={period}
                            variant="full"
                            showCompare={false}
                            showDelete={false}
                            onViewDetail={onViewDetail}
                            onOpenComparison={() => {}}
                            onOpenOurPrice={onOpenOurPrice}
                            onOpenSupplierQuote={onOpenSupplierQuote}
                            onConfirm={onConfirm}
                            onDispute={onDispute}
                            onDelete={() => {}}
                        />
                    </Card>

                    <Alert type={comparison.differenceBanner.type} showIcon message={comparison.differenceBanner.message} />

                    <Row gutter={16}>
                        {comparison.snapshots.map((snapshot) => (
                            <Col xs={24} lg={12} key={snapshot.key}>
                                <SnapshotCard snapshot={snapshot} />
                            </Col>
                        ))}
                    </Row>

                    <Card size="small" title="当前已落地的比较锚点">
                        <PriceComparisonBreakdownTable rows={comparison.breakdownRows} />
                    </Card>

                    <Card size="small" title="后续待接入的分项快照骨架">
                        <PriceComparisonBreakdownTable rows={comparison.plannedBreakdownRows} />
                        <Alert style={{ marginTop: 16 }} type="warning" showIcon message={comparison.futureHint} />
                    </Card>
                </Space>
            )}
        </Modal>
    );
};

export default PriceComparisonModal;
